"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase/InputBase"));
var _CreditCardsInfo = require("./CreditCardsInfo");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "setValue", "label", "setSecurityCodeLength", "invalidErrorMessage", "advanced"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputCreditCard__child_input {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 1rem;\n}";
  var fileName = "InputCreditCard_InputCreditCard";
  var element = document.querySelector("style[data-sass-component='InputCreditCard_InputCreditCard']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputCreditCard = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$setValue = _ref.setValue,
    _setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$setSecurityCodeL = _ref.setSecurityCodeLength,
    setSecurityCodeLength = _ref$setSecurityCodeL === void 0 ? function () {} : _ref$setSecurityCodeL,
    _ref$invalidErrorMess = _ref.invalidErrorMessage,
    invalidErrorMessage = _ref$invalidErrorMess === void 0 ? '' : _ref$invalidErrorMess,
    _ref$advanced = _ref.advanced,
    advanced = _ref$advanced === void 0 ? false : _ref$advanced,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)({
      name: '',
      securityCodelength: 3,
      ccLength: 16,
      logo: ''
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    ccInfo = _useState2[0],
    setCCinfo = _useState2[1];
  var getRawVal = function getRawVal(ccard) {
    var rawVal = ccard && ccard.replace(/[^0-9]/g, '');
    return rawVal;
  };
  var isCcValid = function isCcValid(val) {
    var raw = val.replace(/[^0-9]/g, '');
    if (raw.match(/^(3[47][0-9]{13}|(6541|6556)[0-9]{12}|389[0-9]{11}|3(?:0[0-5]|[68][0-9])[0-9]{11}|65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})|63[7-9][0-9]{13}|(?:2131|1800|35\d{3})\d{11}|9[0-9]{15}|(6304|6706|6709|6771)[0-9]{12,15}|(5019|5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}|(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))|(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}|(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}|(62[0-9]{14,17})|4[0-9]{12}(?:[0-9]{3})?|(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}))$/)) {
      return true;
    }
    return false;
  };
  var pasteHandler = function pasteHandler(e) {
    _setValue(e.clipboardData.getData('Text'));
    setFormat(formatCreditCard(value));
  };
  (0, _react.useLayoutEffect)(function () {
    setFormat(formatCreditCard(value));
    setSecurityCodeLength && setSecurityCodeLength(ccInfo.securityCodelength);
  });
  (0, _react.useEffect)(function () {
    setCCinfo((0, _CreditCardsInfo.creditCardsInfo)(value));
  }, [value]);
  var formatAmex = function formatAmex(ccard) {
    var amexFormat = ccard.length < 5 ? ccard : ccard.length > 4 && ccard.length <= 10 ? "".concat(ccard.slice(0, 4), " - ").concat(ccard.slice(4)) : "".concat(ccard.slice(0, 4), " - ").concat(ccard.slice(4, 10), " - ").concat(ccard.slice(10));
    return amexFormat;
  };
  var formatCreditCard = function formatCreditCard(ccard) {
    var onlyNumbers = getRawVal(ccard);
    var createFormat = ccInfo.name === 'amex' ? formatAmex(onlyNumbers) : onlyNumbers.replace(/(\d{4})(?=\d)/gm, '$1 - ');
    return createFormat;
  };
  var _useState3 = (0, _react.useState)(formatCreditCard(value)),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    format = _useState4[0],
    setFormat = _useState4[1];
  var ccImage = ccInfo.logo ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: ccInfo.logo,
    alt: ccInfo.name !== 'others' ? "".concat(ccInfo.name, " logo") : "Credit Card logo",
    className: "InputCreditCard__child_input"
  }) : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
    id: "ccard",
    label: label,
    ref: ref,
    onPaste: pasteHandler,
    className: "InputCreditCard ".concat(className),
    value: format,
    minLength: 0 // It will prevent its use. The validation for the length is set in the regex.
    ,
    maxLength: ccInfo.name === 'amex' ? 21 : 25 //the format with dashes will determin the character length allowed for this input
    ,
    formatValue: formatCreditCard,
    isValid: isCcValid,
    invalidErrorMessage: invalidErrorMessage || "Please enter a ".concat(ccInfo.name === 'others' && ![15, 16].includes(value.length) ? '15- or 16-digit' : value.length !== ccInfo.ccLength ? "".concat(ccInfo.ccLength.toString(), "-digit") : 'valid credit', " card number"),
    setValue: function setValue(ccard) {
      setFormat(formatCreditCard(ccard));
      _setValue(getRawVal(ccard));
      setSecurityCodeLength && setSecurityCodeLength(ccInfo.securityCodelength);
    },
    advanced: advanced,
    inputChild: ccImage
  }));
});
InputCreditCard.displayName = 'InputCreditCard';
var _default = InputCreditCard;
exports["default"] = _default;